export class Message {
	action: string;
	args: any;
	constructor(action?: string, args?: any) {
		this.action = action;
		this.args = args;
	}
}
 